"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _NicklistUser = _interopRequireDefault(require("./NicklistUser"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const log = _Logger.default.namespace('Nicklist');
var _default = exports.default = {
  components: {
    NicklistUser: _NicklistUser.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data() {
    return {
      self: this,
      userFilter: '',
      userFilterVisible: false,
      aslRefresh: 0,
      // Valeur affichée du compteur "Connecté actuellement" : figée, rafraîchie
      // seulement toutes les 5 s (cf. created) pour ne pas changer trop vite.
      displayedUsersCount: 0
    };
  },
  computed: {
    sortedUsers() {
      // Dépendance réactive : recalculer quand l'ASL (WHO) arrive.
      // eslint-disable-next-line no-unused-expressions
      this.aslRefresh;

      // Get a list of network prefixes and give them a rank number
      const netPrefixes = this.network.ircClient.network.options.PREFIX;
      const prefixOrders = Object.create(null);
      netPrefixes.forEach((prefix, idx) => {
        prefixOrders[prefix.mode] = idx;
      });

      // A few things here:
      // * Since vuejs will sort in-place and update views when .sort is called
      //   on an array, clone it first so that we have a plain array to sort
      // * Keep a map of uppercase nicks to we don't need to call .toUpperCase()
      //   on each one all the time. This is a hot function!
      const nickMap = Object.create(null);
      const users = [];
      const bufferUsers = this.buffer.users;
      // Recherche multi-critères : pseudo, sexe, âge, lieu (cf. placeholder).
      const filter = this.userFilter.trim().toLowerCase();

      // Pseudos toujours masqués de la nicklist (services AppChat)
      const hiddenNicks = ['partner'];
      // L'utilisateur courant est affiché à part (carte fixe "VOUS" en tête) :
      // on l'exclut de la liste défilante pour éviter le doublon.
      const ourNick = (this.network.nick || '').toLowerCase();
      const serviceBots = [];
      Object.entries(bufferUsers).forEach(([uppercaseNick, user]) => {
        if (hiddenNicks.includes(user.nick.toLowerCase()) || user.nick.toLowerCase() === ourNick) {
          return;
        }
        nickMap[user.nick] = uppercaseNick;
        if (!filter || this.matchesFilter(user, filter)) {
          users.push(user);
          if (Misc.isServiceBot(user)) {
            serviceBots.push(user);
          }
        }
      });

      // Bots de service (tous affichés « Robot ») : s'il y en a plusieurs, ne
      // garder que le plus haut gradé (ex. ADMIN devant STAFF) — sinon deux
      // entrées « Robot » identiques apparaissent. Rang = prefixOrders (plus
      // petit = plus haut gradé) ; sans mode → relégué en dernier.
      if (serviceBots.length > 1) {
        const rankOf = u => {
          const order = prefixOrders[this.buffer.userMode(u)];
          return order === undefined ? Infinity : order;
        };
        let keep = serviceBots[0];
        serviceBots.forEach(u => {
          if (rankOf(u) < rankOf(keep)) {
            keep = u;
          }
        });
        const drop = new Set(serviceBots.filter(u => u !== keep));
        for (let i = users.length - 1; i >= 0; i--) {
          if (drop.has(users[i])) {
            users.splice(i, 1);
          }
        }
      }
      const bufferId = this.buffer.id;
      const groupAway = this.$state.setting('nicklistGroupAway');
      return users.sort((a, b) => {
        const bufferA = a.buffers[bufferId];
        const bufferB = b.buffers[bufferId];
        if (!bufferA) {
          const msg = 'Nicklist.sortedUsers() User A does not have the buffer in its list!';
          log.error(msg, a.nick, a.buffers);
          return -1;
        }
        if (!bufferB) {
          const msg = 'Nicklist.sortedUsers() User B does not have the buffer in its list!';
          log.error(msg, b.nick, b.buffers);
          return 1;
        }
        const modesA = bufferA.modes;
        const modesB = bufferB.modes;

        // Neither user has a prefix, compare text
        if (modesA.length === 0 && modesB.length === 0) {
          // Compare away status
          if (groupAway) {
            if (a.away && !b.away) {
              return 1;
            }
            if (!a.away && b.away) {
              return -1;
            }
          }
          return Misc.strCompare(nickMap[a.nick], nickMap[b.nick]);
        }

        // Compare via prefixes..
        if (modesA.length > 0 && modesB.length === 0) {
          return -1;
        }
        if (modesA.length === 0 && modesB.length > 0) {
          return 1;
        }

        // Both users have a prefix so find the highest ranking one
        const aP = prefixOrders[this.buffer.userMode(a)];
        const bP = prefixOrders[this.buffer.userMode(b)];
        if (aP > bP) {
          return 1;
        } else if (aP < bP) {
          return -1;
        }

        // Prefixes are the same, compare away status
        if (groupAway) {
          if (a.away && !b.away) {
            return 1;
          }
          if (!a.away && b.away) {
            return -1;
          }
        }

        // Prefixes are the same, resort to comparing text
        return Misc.strCompare(nickMap[a.nick], nickMap[b.nick]);
      });
    },
    allUsersCount() {
      return Object.keys(this.buffer.users).length;
    },
    shouldShowAvatars() {
      return this.buffer.setting('nicklist_avatars');
    },
    useColouredNicks() {
      return this.buffer.setting('coloured_nicklist');
    },
    selfUser() {
      // Utilisateur courant, affiché dans la carte fixe "VOUS" en tête de liste.
      return this.network ? this.network.currentUser() : null;
    }
  },
  watch: {
    // Changement de salon → maj IMMÉDIATE du compteur « En ligne » (sans attendre
    // le tick de 5 s, qui ne sert qu'à lisser les join/quit dans un même salon).
    'buffer.name': function onActiveBufferChange() {
      this.displayedUsersCount = this.allUsersCount;
    }
  },
  created() {
    // L'ASL (âge/sexe) est posé par le asl après le WHO, de façon non
    // réactive. On force le recalcul de la liste à chaque réception de WHO pour
    // que l'ASL s'affiche dès qu'il est disponible (sans attendre un autre
    // changement de la liste d'utilisateurs).
    this.listen(this.$state, 'irc.wholist', () => {
      this.aslRefresh += 1;
    });

    // Compteur "Connecté actuellement" rafraîchi toutes les 5 s seulement
    // (au lieu d'être réactif à chaque join/quit, ce qui le faisait changer
    // trop vite). this.setInterval est le mixin auto-nettoyé (cf. main.js).
    this.displayedUsersCount = this.allUsersCount;
    this.setInterval(() => {
      this.displayedUsersCount = this.allUsersCount;
    }, 5000);
  },
  methods: {
    openQuery(user) {
      const buffer = this.$state.addBuffer(this.buffer.networkid, user.nick);
      this.$state.setActiveBuffer(buffer.networkid, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.sidebarState.close();
      }
    },
    openUserbox(user) {
      this.$state.$emit('userbox.show', user, {
        buffer: this.buffer
      });
    },
    // Recherche multi-critères (pseudo, sexe, âge, lieu). `filter` est déjà en
    // minuscules et trimé. On matche en « OU » sur les 4 champs de l'ASL.
    matchesFilter(user, filter) {
      if (user.nick && user.nick.toLowerCase().indexOf(filter) !== -1) {
        return true;
      }
      const asl = user.asl || {};
      // Âge (ex. "25" ou "25 ans")
      if (asl.a && (String(asl.a) + ' ans').indexOf(filter) !== -1) {
        return true;
      }
      // Lieu
      if (asl.l && String(asl.l).toLowerCase().indexOf(filter) !== -1) {
        return true;
      }
      // Sexe : on cherche sur les libellés FR (homme/femme) pour éviter que
      // "male" matche "female". On dérive le libellé depuis la clé ASL.
      const sex = (asl.s || '').toLowerCase();
      let sexLabel = '';
      if (sex.indexOf('female') !== -1 || sex.indexOf('femme') !== -1 || sex.indexOf('fehomme') !== -1) {
        sexLabel = 'femme';
      } else if (sex.indexOf('male') !== -1 || sex.indexOf('homme') !== -1) {
        sexLabel = 'homme';
      }
      if (sexLabel && sexLabel.indexOf(filter) !== -1) {
        return true;
      }
      return false;
    },
    toggleUserFilter() {
      this.userFilterVisible = !this.userFilterVisible;
      if (this.userFilterVisible) {
        this.$nextTick(() => this.$refs.user_filter.focus());
      } else {
        this.userFilter = '';
      }
    },
    onFilterBlur() {
      if (!this.userFilter.trim()) {
        this.userFilter = '';
        this.userFilterVisible = false;
      }
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["Nicklist"]
window._app_exports.components.Nicklist = exports.default ? exports.default : exports;
